export default __webpack_public_path__ + "static/media/Ramadan_V2_1440x300.4b192618.png";